import { render } from "./parallax.vue?vue&type=template&id=99c93410&scoped=true"
import script from "./parallax.vue?vue&type=script&lang=js"
export * from "./parallax.vue?vue&type=script&lang=js"

import "./parallax.vue?vue&type=style&index=0&id=99c93410&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-99c93410"

export default script